import React from "react";
import Hero from "../../components/newProdictPage/Hero/Hero";
import LabelInfo from "../../components/newProdictPage/LabelInfo/LabelInfo";
import Languages from "../../components/newProdictPage/Languages/Languages";
import Learning from "../../components/newProdictPage/Learning/Learning";
import SuccessStory from "../../components/newProdictPage/successStory/SuccessStory";
import useSetTags from "../../hooks/useSetTags";
import { CONFIG } from "../../constants/TitleConfig";

const NewProductPage = ({ data }) => {
  useSetTags(CONFIG);
  return (
    <div>
      <Hero data={data.hero} />
      <LabelInfo data={data.labelInfo} />
      <Learning data={data.learning} />
      <Languages data={data.languages} />
      <SuccessStory data={data.success} />
    </div>
  );
};

export default NewProductPage;
